<template>
    <div>
        <v-app-bar clipped-right color="blue-grey" dark>
            <v-toolbar-title color="white">
                <router-link class="logo" :to="{name: 'sale-offers'}">WM Admin</router-link>
            </v-toolbar-title>
            <Navigation />
            <v-spacer/>
            <div>
                <v-icon @click="goToUserAccount">mdi-account</v-icon>
                ID: {{ $store.state.user.identity.userId }}
            </div>
            <v-icon class="ml-4" @click="logout">mdi-exit-to-app</v-icon>
        </v-app-bar>
        <v-main>
            <v-container fluid>
                <v-row class="fill-height">
                    <v-col>
                        <transition name="fade">
                            <router-view></router-view>
                        </transition>
                        <Snackbar></Snackbar>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
    </div>
</template>

<script>
    import {auth} from '../main';
    import Navigation from '../components/Navigation';
    import Snackbar from '../components/Snackbar';

    export default {
        components: {Navigation, Snackbar},
        methods: {
            goToUserAccount() {
                this.$router
                    .push({name: 'user-account'})
                    .catch((error) => {
                        if (String(error).includes('Avoided redundant navigation to current location')) {
                            return;
                        }

                        throw error;
                    });
            },
            logout() {
                auth.logout();
            }
        }
    }
</script>

<style scoped>
    .logo {
        color: white;
        text-decoration: none;
    }
</style>